import useAppDialog from "../../hooks/useAppDialog"
import { DialogResult } from "./dialogTypes"
import MessageDialog from "./MessageDialog"

// This component is for managing all modal dialogs within the app.
const AppDialogs = () => {
  const { dialogParams, resolve, isMessageDialog, closeDialog_Message } = useAppDialog()
  return (
    <>
      {isMessageDialog && dialogParams?.custPolId &&
        <MessageDialog
          open={isMessageDialog}
          custPolicyID={dialogParams.custPolId}
          viewOnly={dialogParams.viewOnly}
          onSubmit={(message) => {
            resolve?.({ dialogResult: DialogResult.OK, data: { message } })
            // Don't close — keep user in Messaging Center until they click Cancel/Close
          }}
          onClose={() => {
            resolve?.({ dialogResult: DialogResult.Cancel })
            closeDialog_Message()
          }}
        />
      }
    </>
  )
}
export default AppDialogs